import { useTranslation } from "react-i18next";
import { Text, Box, Flex, Image } from "@chakra-ui/react";
import arrowOpen from "../image/arrow_open.png";
import arrowClose from "../image/arrow_close.png";
import contentBgExpanded from "../image/content_bg_expand.png";
import { useState } from "react";
import contentBg from "../image/content_bg.png";

/**
 * @description 單一公告卡片元件，顯示公告的標題和內容，並提供展開/收合功能
 * @params {Object} item 公告資料，包含公告的標題和內容等資訊
 * @returns {JSX.Element} 單一公告卡片元件
 */
const AnnouncementCard = ({ item } = {}) => {
  const [expanded, setExpanded] = useState(false);
  const { uid } = item;

  const handleExpanded = () => {
    setExpanded(!expanded);
  };
  return (
    <Box
      bgImage={`url(${expanded ? contentBgExpanded : contentBg})`}
      bgSize="100% 100%"
      key={uid}
      mb={4}
      p={4}
      h={expanded ? "250px" : "100px"}
      display={"flex"}
      flexDirection={"column"}
    >
      <Flex
        w="100%"
        alignItems={"center"}
        gap={5}
        justifyContent={"space-between"}
      >
        <Text
          color="white"
          fontWeight="bold"
          fontSize="2xl"
          flex={1}
          noOfLines={1}
          textShadow="0 0 5px #805AD5, 0 0 10px #6B46C1"
        >
          {item.currentLng.title}
        </Text>
        <Box
          boxSize={30}
          mr={5}
          cursor={"pointer"}
          _hover={{ transform: "scale(1.2)" }}
          onClick={handleExpanded}
        >
          <Image src={!expanded ? arrowOpen : arrowClose} />
        </Box>
      </Flex>
      <Text noOfLines={expanded ? "" : 1} flex={1} overflow={"scroll"} mt={2}>
        {item.currentLng.content}
      </Text>
    </Box>
  );
};

/**
 * @description 維護公告卡片
 * @params {Array} announcementList 公告列表資料，包含公告的標題和內容等資訊
 * @returns {JSX.Element} 維護公告卡片元件
 */
const AnnouncementContent = ({ announcementList }) => {
  const { t } = useTranslation();

  if (announcementList.length === 0)
    return (
      <Text textAlign={"center"} padding={"1em"}>
        {t("common.No announcements found.")}
      </Text>
    );
  return (
    <>
      {announcementList?.map((item, index) => (
        <AnnouncementCard item={item} key={item.uid} />
      ))}
    </>
  );
};
export default AnnouncementContent;
